"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatableModel = void 0;
const mobx_1 = require("mobx");
const validation_1 = require("@zajno/common/validation");
const arrays_1 = require("@zajno/common/async/arrays");
const EmptyValidator = () => 0;
class ValidatableModel {
    constructor() {
        this._validator = null;
        this._strings = null;
        this._error = null;
        this._validationError = null;
        this._validateOnChange = false;
        (0, mobx_1.makeObservable)(this, {
            _error: mobx_1.observable,
            reset: mobx_1.action,
        });
    }
    get isValid() { return !this._error; }
    get error() { return this._error; }
    setValidationConfig(config) {
        this._validator = (config === null || config === void 0 ? void 0 : config.validator) || EmptyValidator;
        this._strings = config === null || config === void 0 ? void 0 : config.errors;
        return this;
    }
    validateOnChange(enable = true) {
        this._validateOnChange = enable;
        return this;
    }
    async testValidate(value) {
        if (this._validator) {
            const res = await this._validator(value);
            return res;
        }
        return null;
    }
    async validate() {
        if (!this._validator) {
            return true;
        }
        try {
            const validationResult = await this._validator(this.valueToValidate);
            this._validationError = !validationResult
                ? null
                : new validation_1.ValidationError('Unknown error', validationResult);
        }
        catch (err) {
            this._validationError = err;
        }
        (0, mobx_1.runInAction)(() => {
            if (!this._validationError) {
                this._error = null;
            }
            else {
                const code = this._validationError.code;
                this._error = this._strings && this._strings[code];
            }
        });
        return this._validationError == null;
    }
    async getIsInvalid() {
        const valid = await this.validate();
        return !valid;
    }
    reset() {
        this._validationError = null;
        this._error = null;
    }
    static async IsSomeInvalid(validatables, stopOnFail = true) {
        if (stopOnFail) {
            return (0, arrays_1.someAsync)(validatables, async (v) => !(await v.validate()));
        }
        const results = await Promise.all(validatables.map(v => v.validate()));
        return results.some(r => !r);
    }
}
exports.ValidatableModel = ValidatableModel;
//# sourceMappingURL=Validatable.js.map